module.exports = __webpack_public_path__ + "static/media/water3.e9127334.svg";